import PatientHeaderSections from './PatientHeaderSections';

export default PatientHeaderSections;